@if (document(); as externalDoc) {
<div class="bg-white rounded-4 overflow-hidden mb-3 external-signing-card border position-relative">
  <div
    class="bg-light border-bottom px-3 py-2 d-flex align-items-center justify-content-between w-100 flex-lg-nowrap flex-wrap gap-2"
  >
    <div class="d-flex align-items-center gap-2 flex-fill">
      <div class="d-flex gap-2 align-items-center flex-wrap">
        <div class="d-flex align-items-center gap-2 me-2">
          <div class="align-items-center bg-body-secondary d-flex justify-content-center rounded-3 text-primary wh-32">
            <i class="pi pi-file text-dark"></i>
          </div>
          <h5 class="fw-semibold mb-0 text-dark">{{ documentCategory() }}</h5>
        </div>

        <span class="text-grayborder d-none d-md-block">|</span>
        @if (documentUrl()) {
        <a
          class="align-items-center d-flex fs-14 gap-1 text-decoration-none fw-500 external-view-link"
          role="button"
          (click)="openPreviewModal()"
        >
          <i class="bi bi-eye lh-1"></i>
          View Document
        </a>
        }
      </div>
    </div>
    @if (documentUrl()) {
    <button type="button" class="btn btn-outline-secondary btn-h35 rounded-pill ms-auto" (click)="onReplace()">
      <i class="bi bi-arrow-repeat lh-1"></i>
      Replace
    </button>
    }
  </div>

  <div class="d-flex flex-wrap align-items-center gap-2 px-3 py-2">
    <div class="d-flex align-items-center gap-2 flex-wrap flex-fill">
      <h3 class="m-0 fw-semibold">Notes:</h3>
      <p class="m-0">{{ document()?.note ?? '' }}</p>
    </div>
  </div>
</div>

<ng-template #documentPreviewModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">{{ selectedPreview()?.name }}</h2>
      <span (click)="modal.dismiss('Cross click')" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body overflow-y-auto">
      @if (selectedPreview()?.url) {
      <lib-doc-preview [article]="selectedPreview()!.url"></lib-doc-preview>
      } @else {
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.dismiss('Close')">Close</button>
    </div>
  </div>
</ng-template>
} @else {
<div class="border rounded-4 p-4 bg-light text-muted">No external document available.</div>
}
